import * as $ from 'jquery';
import Swal from 'sweetalert2';

export default (function () {
    window.Swal = Swal

    $(document).on('click', "form.delete button", function(e) {
        var _this = $(this);
        e.preventDefault();
        Swal.fire({
            icon: 'error',
            title: 'Προσοχή', // Opération Dangereuse
            text: $(this).data( "msg" ), // Êtes-vous sûr de continuer ?
            showCancelButton: true,
            confirmButtonColor: 'null',
            cancelButtonColor: 'null',
            confirmButtonText: 'Διαγραφή', // Oui, sûr
            cancelButtonText: 'Άκυρο', // Annuler
            customClass: {
                confirmButton: 'btn btn-lg btn-danger mx-1',
                cancelButton: 'btn btn-lg btn-cancel mx-1'
            },
            buttonsStyling: false
        }).then(res => {
            if (res.value) {
                _this.closest("form").submit();
            }
        });
    });
}())
